<template>
  <div class="the-header-area" v-if="showpan" v-click-outside="hideAreaPanel">
    <span @click="isPanelShow = true">{{ currentArea.name }}<i class="ri-arrow-down-s-fill"></i></span>
    <transition name="area-panel">
      <div class="area-panel" v-show="isPanelShow">
        <div class="area-item"
             :class="{ active: item.code === currentArea.code }"
             v-for="item in areaList"
             :key="item.code"
             @click="changeArea(item)">{{ item.name }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { configArea } from '@/config/system'
import Bus from '@/api/bus'
import { clickOutside } from '@/utils/directives'
import { mapGetters } from 'vuex'
export default {
  name: 'TheHeaderArea',
  directives: { clickOutside },
  data () {
    return {
      showpan:true,
      // 显示区域选择面板
      isPanelShow: false,
      // 区域列表
      areaList: configArea
    }
  },
  mounted(){
    Bus.$on('val', (data) => {
        this.showpan=data
      })
  },
  computed: {
    ...mapGetters(['currentArea'])
  },
  methods: {
    // 隐藏区域选择面板
    hideAreaPanel (e) {
      const that = this
      that.isPanelShow = false
    },
    // 切换区域
    changeArea (areaItem) {
      const that = this
      that.isPanelShow = false
      that.$store.commit('setCurrentArea', areaItem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-header-area{
  position: relative;
  display: inline-block;
  margin-left: 16px;
  height: 36px;
  line-height: 36px;
  vertical-align: middle;
  span{
    color: #ddd;
    cursor: pointer;
    transition: $transitionTime;
    &:hover{
      color: #fff;
    }
    i{
      margin-left: 4px;
      font-size: 16px;
      vertical-align: -3px;
    }
  }
}
.area-panel{
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 22;
  width: 440px;
  margin-top: 12px;
  padding: $paddingVertical $paddingHorizontal 12px;
  line-height: $lineHeight;
  background: #fff;
  box-shadow: 0 3px 11px 0 rgba(146, 146, 146, 0.5);
  &:before{
    content: '';
    position: absolute;
    left: 24px;
    bottom: 100%;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 8px;
    border-color: transparent transparent #fff;
  }
  .area-item{
    display: inline-block;
    height: 32px;
    padding: 0 16px;
    margin-right: 8px;
    margin-bottom: 4px;
    text-align: center;
    font-size: 13px;
    line-height: 30px;
    background: #F5F6FA;
    background: linear-gradient(270deg, rgba(251, 251, 253, 0.7) 0%, #F5F6FA 100%);
    border-radius: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: $transitionTime;
    cursor: pointer;
    &.active,
    &:hover{
      color: $colorPrimary;
    }
  }
}
/* area-panel transition */
.area-panel-enter-active{
  transition: all .5s;
}

.area-panel-enter,
.area-panel-leave-active {
  opacity: 0;
  transform: translateY(32px);
}

.area-panel-move {
  transition: all .5s;
}

.area-panel-leave-active {
  position: absolute;
  transition: all .5s;
}
</style>
